import Type1FlightTopFilters from "./FlightTopFilters/Type1FlightTopFilters";
import Type4FlightTopFilters from "./FlightTopFilters/Type4FlightTopFilters";


const TopFilters = (props) => {

    const {
        flights,
        canShowPrice,
        PriceMarkupValue,
        CURRENCY_SYMBOL,
        flightsMinPrice,
        flightsSliderMaxPrice,
        flightsMaxPrice,
        slidePriceFilter,
        SLIDER_MIN_PERCENT,
        priceSlider,
        isShowTimesFilter,
        filterTimes,
        filtersByTimes,
        filterFlights,
        bookingEngine,
        hideTimesFilter,
        hasNewMessageFromParent,
        currentParentMessge,
        showTimesFilter,
        isShowBagsFilter,
        checkedBagsFilterQuantity,
        carryOnBagsFilterQuantity,
        setCheckedBagsFilterQuantity,
        setCarryOnBagsFilterQuantity,
        hideBagsFilter,
        maxCheckedBagsFilter,
        maxCarryOnBagsFilter,
        filterBags,
        showBagsFilter,
        isShowDurationFilter,
        flightsMinDuration,
        flightsMaxDuration,
        D_SLIDER_MIN_PERCENT,
        slideDurationFilter,
        durationSlider,
        flightsSliderMaxDuration,
        hideDurationFilter,
        showDurationFilter,

    } = props;

    const cardType = parseInt((bookingEngine.searchResultTopFilterCard || 1));

    return <div>
        {
            cardType===1 &&
            <Type1FlightTopFilters 
                flights={flights}
                bookingEngine={bookingEngine}
                canShowPrice={canShowPrice}
                PriceMarkupValue={PriceMarkupValue}
                CURRENCY_SYMBOL={CURRENCY_SYMBOL}
                flightsMinPrice={flightsMinPrice}
                flightsSliderMaxPrice={flightsSliderMaxPrice}
                flightsMaxPrice={flightsMaxPrice}
                slidePriceFilter={slidePriceFilter}
                SLIDER_MIN_PERCENT={SLIDER_MIN_PERCENT}
                priceSlider={priceSlider}
                isShowTimesFilter={isShowTimesFilter}
                filterTimes={filterTimes}
                filtersByTimes={filtersByTimes}
                filterFlights={filterFlights}
                hideTimesFilter={hideTimesFilter}
                hasNewMessageFromParent={hasNewMessageFromParent}
                currentParentMessge={currentParentMessge}
                showTimesFilter={showTimesFilter}
                isShowBagsFilter={isShowBagsFilter}
                checkedBagsFilterQuantity={checkedBagsFilterQuantity}
                carryOnBagsFilterQuantity={carryOnBagsFilterQuantity}
                setCheckedBagsFilterQuantity={setCheckedBagsFilterQuantity}
                setCarryOnBagsFilterQuantity={setCarryOnBagsFilterQuantity}
                hideBagsFilter={hideBagsFilter}
                maxCheckedBagsFilter={maxCheckedBagsFilter}
                maxCarryOnBagsFilter={maxCarryOnBagsFilter}
                filterBags={filterBags}
                showBagsFilter={showBagsFilter}
                isShowDurationFilter={isShowDurationFilter}
                flightsMinDuration={flightsMinDuration}
                flightsMaxDuration={flightsMaxDuration}
                D_SLIDER_MIN_PERCENT={D_SLIDER_MIN_PERCENT}
                slideDurationFilter={slideDurationFilter}
                durationSlider={durationSlider}
                flightsSliderMaxDuration={flightsSliderMaxDuration}
                hideDurationFilter={hideDurationFilter}
                showDurationFilter={showDurationFilter}
            />
        }
        {
            cardType===4 &&
            <Type4FlightTopFilters 
                flights={flights}
            />
        }
    </div>
}

export default TopFilters;